import Vue from 'vue'
import Vuex from 'vuex'
import * as MUTATION from './const.mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mousePosition: {x: 0, y: 0},
    scrollTop: 0,
    globalData: null,
    /* PRISMIC DATA */
    header: null,
    footer: null,
    homepage: null,
    services: null,
    contact: null,
    legals: null
  },
  mutations: {
    [MUTATION.SET_MOUSE_POSITION] (state, pos) {
      state.mousePosition = pos
    },
    [MUTATION.SET_SCROLL_TOP] (state, top) {
      state.scrollTop = top
    },
    [MUTATION.SET_GLOBAL_DATA] (state, data) {
      state.globalData = data
    },
    /* PRISMIC DATA */
    [MUTATION.SET_HEADER] (state, data) {
      state.header = data
    },
    [MUTATION.SET_FOOTER] (state, data) {
        state.footer = data
    },
    [MUTATION.SET_HOMEPAGE] (state, data) {
        state.homepage = data
    },
    [MUTATION.SET_SERVICES] (state, data) {
        state.services = data
    },
    [MUTATION.SET_CONTACT] (state, data) {
        state.contact = data
    },
    [MUTATION.SET_LEGALS] (state, data) {
        state.legals = data
    }
  },
  actions: {
    setMousePosition ({ state, commit }, pos) {
      commit(MUTATION.SET_MOUSE_POSITION, pos)
    },
    setScrollTop({ state, commit }, top) {
      commit(MUTATION.SET_SCROLL_TOP, top)
    },
    setGlobalData({ state, commit }, data) {
      commit(MUTATION.SET_GLOBAL_DATA, data)
    },
    /* PRISMIC DATA */
    setHeader({ state, commit }, data) {
        commit(MUTATION.SET_HEADER, data)
    },
    setFooter({ state, commit }, data) {
        commit(MUTATION.SET_FOOTER, data)
    },
    setHomepage({ state, commit }, data) {
        commit(MUTATION.SET_HOMEPAGE, data)
    },
    setServices({ state, commit }, data) {
        commit(MUTATION.SET_SERVICES, data)
    },
    setContact({ state, commit }, data) {
        commit(MUTATION.SET_CONTACT, data)
    },
    setLegals({ state, commit }, data) {
        commit(MUTATION.SET_LEGALS, data)
    }
  },
  getters: {
    getMousePosition (state) {
      return state.mousePosition
    },
    getScrollTop(state){
      return state.scrollTop
    },
    getGlobalData(state)
    {
      return state.globalData
    },
    /* PRISMIC DATA */
    getHEADER(state)
    {
        return state.header
    },
    getFOOTER(state)
    {
        return state.footer
    },
    getHOMEPAGE(state)
    {
        return state.homepage
    },
    getCONTACT(state)
    {
        return state.contact
    },
    getSERVICES(state)
    {
        return state.services
    },
    getLEGALS(state)
    {
        return state.legals
    }
  }
})
